import { useState, useMemo, useEffect, useRef } from 'react';
import '../../../assets/css/StudentDashboard.css'
import { useNavigate, useNavigation } from 'react-router-dom';
import { Deletedata, getBlob, getData, patchData, postBlob, Postdata, PostFileData, updateData } from '../../../API/GlobalApi.js';
import { handlePaginate } from '../../../Utils/handlePagination.js';
import SpinnerLoader from '../../../Utils/Spinner.js';
import SearchingBar from '../../../Utils/Searching.js';
import Notifier from '../../../Utils/notify.js';
import AdvanceTable from '../../../Utils/AdvanceTables.js';
import { AddBankAccounts } from '../../../Component/Modals/AddBankAccounts.js';
import TableSkeleton from '../../../Utils/TableSkeleton.js';
import { formatDateDDMMYYYY, formatDateDDMMYYYYByString } from '../../../Utils/data&dateTime.js';
import edit from '../../../assets/icons/editnew.svg';
import exporticon from '../../../assets/icons/export-data.svg';
import ActivitiesShortDetails from './ActivitiesShortDetails.js';
import { ActivityCard } from './ActivitiesCardView.js';
import CardSkeleton from '../../../Utils/CardSkeleton.js';
import { useHasPermission } from '../../../Utils/checkPermissions.js';
import { dummyStudentActivityData } from './data.js';
import SearchBar from '../../../Component/SearchBar.js';
import { GridToggleIcon, reactSelectStyles } from '../../../Utils/selectBoxStyle.js';
import Select from 'react-select'

const ActivitiesDashboard = () => {

    const skipSpinnerRef = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSearchLoading, setSearchLoading] = useState(false);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [activitiesData, setactivitiesData] = useState([])
    const [selectedInstitutionsBank, setSelectedInstitutionsBank] = useState([]);
    const [filterActivities, setfilterActivities] = useState([])
    const pageSize = 10;
    const pageCounts = Math.ceil(totalCount / pageSize);
    const [modalMode, setModalMode] = useState('create');
    const [filterQueryString, setFilterQueryString] = useState('');
    const navigate = useNavigate();
    const [addBankAccountsModal, setAddBankAccountsModal] = useState(false)
    const [filterLoading, setFilterLoading] = useState(false);
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    const [activityTypeOptions, setActivityTypeOptions] = useState([]);
    const getActivityEventsData = async () => {
        try {
            const response = await getData("academics/activity-events/");

            const options = response?.map(ev => ({
                value: ev.id,     // send to backend
                label: ev.name,   // show in UI
            })) || [];

            setActivityTypeOptions(options);
        } catch (error) {
            console.error("Failed to fetch activity types", error);
        }
    };

    useEffect(() => {

        getActivityEventsData()
    }, [])
    const hasPermission = useHasPermission();
    const [isSearching, setIsSearching] = useState(false);

    const getInstitutionsBank = async (page = 0) => {

        const pageNumber = page + 1;
        const url = filterQueryString
            ? `academics/activities/?${filterQueryString}&page=${pageNumber}`
            : `academics/activities/?page=${pageNumber}`;

        if (!skipSpinnerRef.current) {
            if (isInitialLoad) setIsLoading(true);
            else setSearchLoading(true);
        }
        try {
            const response = await getData(url);
            setactivitiesData(response?.results);
            setfilterActivities(response.results)
            setTotalCount(response?.count)
        } catch (error) {
            Notifier.error(error)
            setactivitiesData([]);
            setTotalCount(0);
        } finally {

            if (!skipSpinnerRef.current) {
                if (isInitialLoad) {
                    setIsLoading(false);
                    setIsInitialLoad(false);
                } else {
                    setSearchLoading(false);
                }
            }
            skipSpinnerRef.current = false;
            setFilterLoading(false);

        }
    };


    const currentPageRef = useRef(currentPage);

    useEffect(() => {
        if (isSearching) return; // 🚫 STOP main API during search

        currentPageRef.current = currentPage;
        getInstitutionsBank(currentPage);
    }, [currentPage, filterQueryString]);


    useEffect(() => {
        const params = new URLSearchParams();

        if (selectedActivityType) {
            params.set("event_id", selectedActivityType.value);
        }

        setFilterLoading(true); // ✅ Start spinner
        setFilterQueryString(params.toString());
    }, [selectedActivityType]);


    const handleRowClick = async (activityId, row, event) => {
        try {
            const activityData = row?.original || row;
            setSelectedInstitutionsBank(activityData);
            const clickedElement = event?.target;
            const isNameClick = clickedElement?.closest('.item-name-clickable');
            if (isNameClick) {
                navigate(`/manage-activity/${activityId}`);
            }
        } catch (error) {
            console.error('Error selecting item:', error);
        }
    };



    const sourceData = useMemo(() => {
        return filterQueryString ? filterActivities : activitiesData;
    }, [activitiesData, filterActivities, filterQueryString]);

    const formattedData = useMemo(() => {
        return sourceData?.map((event) => ({
            id: event.id,
            activity_name: event.activity_name,
            description: event.description,
            start_date: event.start_date,
            end_date: event.end_date,
            total_students: event.total_students,
            employee_list: event.employee_list,
            exam_start_date: event.exam_start_date,
            students_summary: event.students_summary,
            completed_students: event.completed_students,
            total_students: event.total_students,
            created_by: event.created_by,
            academic_event_type: event.academic_event_type,
            practical_subject: event.practical_subject,
            // admit_status_count: event.admit_status_count,
            // details: event.details,
            handleRowClick, // for table row action
        }));
    }, [sourceData]);


    // 👉 Auto-select first activity on initial page load
    useEffect(() => {
        if (activitiesData && activitiesData.length > 0) {
            setSelectedInstitutionsBank(activitiesData[0]);
        }
    }, []);



    const handleStatus = async (row) => {

    };

    const handleEditClick = (row) => {
        setSelectedInstitutionsBank(row);
        setModalMode('edit');
        setAddBankAccountsModal(true)
    };

    const columns = useMemo(
        () => [

            {
                Header: "Activity Name",
                accessor: "activity_name",
                disableSortBy: true,
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: "pointer" }} >
                        <p
                            onClick={(e) => handleRowClick(row.original.id, row, e)}
                            className='item-name-clickable'
                            style={{
                                display: "block",  // ensure block
                                width: "100%",     // take full width
                                textAlign: "left",
                                color: "#222F3E",
                                fontWeight: 500,
                                margin: 0,
                                textDecoration: 'underline'

                            }}
                        >
                            {row.original.activity_name}
                        </p>


                        <span>{row.original.description}</span>
                    </div>
                )
            }
            ,
            {
                Header: () => <p style={{ textAlign: 'left' }}>Time Line</p>,
                accessor: 'start_date',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const startDate = row.original.start_date || null;
                    const endDate = row.original.end_date || null;

                    return (
                        <div>
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {startDate ? formatDateDDMMYYYY(startDate) : "-"}
                            </p>
                            <p style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                                {endDate ? formatDateDDMMYYYY(endDate) : "-"}
                            </p>
                        </div>
                    );
                }
            },


            // {
            //     Header: () => <p style={{ textAlign: 'left' }}>Status</p>,
            //     accessor: 'status',
            //     disableSortBy: true,
            //     Cell: ({ row }) => (
            //         <p style={{ margin: 0 }}>
            //             {row.original.status
            //                 ? row.original.status.charAt(0).toUpperCase() + row.original.status.slice(1).toLowerCase()
            //                 : ""}
            //         </p>
            //     )

            // },

            {
                Header: () => <p style={{ textAlign: 'left' }}>Assigned To</p>,
                accessor: 'assigned_to',
                disableSortBy: true,
                Cell: ({ row }) => {
                    const assigned = row.original.employee_list || [];
                    const assignedNames = assigned.map(emp => emp.name); // extract names

                    return (
                        <div style={{ textAlign: 'left', color: '#222F3E', margin: 0 }}>
                            {assignedNames.length > 0 ? assignedNames.join(", ") : "-"}
                        </div>
                    );
                }
            },

            {
                Header: 'Action',
                Cell: ({ row }) => {
                    return (
                        <div style={{ display: 'flex', gap: '10px' }}
                            data-tooltip-id="admission-tip" data-tooltip-content="Disable/Enable">
                            <img src={edit} style={{ cursor: 'pointer' }} alt="Edit"
                                // onClick={() => handleEditClick(row.original.id, row)}
                                data-tooltip-id="admission-tip" data-tooltip-content="Edit" title='Edit details' />
                            <div className="form-check form-switch custom-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckDefault"
                                    style={{ cursor: 'pointer' }}
                                    checked={row.original.status}
                                    // onChange={() => handleStatus(row)}
                                    title='Status' />
                            </div>

                        </div>
                    );
                },
            },
        ],
        []
    );


    const handleSetSearchResults = (data) => {
        setfilterActivities(Array.isArray(data) ? data : []);
    };

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
        handlePaginate({
            selectedPage: selected,
            url: 'finance/academic-group-fee-discounts/',
            filterQueryString,
            setResults: handleSetSearchResults,
            setTotalCount,
            setFilterQueryString,
        });
    }


    const [viewType, setViewType] = useState('card');

    const handleToggleView = (view) => {
        setViewType(view);
        localStorage.setItem("activityView", view);
    };
    useEffect(() => {
        const savedView = localStorage.getItem("activityView");
        if (savedView) {
            setViewType(savedView);
        }
    }, []);


    const [searchValue, setSearchValue] = useState("");
    const [studentSuggestions, setStudentSuggestions] = useState([]);
    const [showStudentSuggestions, setShowStudentSuggestions] = useState(false);
    const [suggestionLoading, setSuggestionLoading] = useState(false);
    const fetchStudentActivitySuggestions = async (query) => {
        const url = `academics/activities/search-registration/?search=${encodeURIComponent(query)}`;
        return await getData(url);
    };
    useEffect(() => {
        if (!searchValue || searchValue.length < 2) {
            setStudentSuggestions([]);
            setShowStudentSuggestions(false);
            setSuggestionLoading(false);
            setIsSearching(false);
            return;
        }

        const timer = setTimeout(async () => {
            try {
                setSuggestionLoading(true);
                setIsSearching(true);

                const response = await fetchStudentActivitySuggestions(searchValue);

                const data = Array.isArray(response)
                    ? response
                    : response?.results || [];

                // 🔥 AUTO REDIRECT IF ONLY ONE RESULT
                if (data.length === 1) {
                    navigate(`/manage-activity/${data[0].id}`, {
                        state: {
                            prefillSearch: searchValue
                        }
                    });
                    setShowStudentSuggestions(false);
                    return; // ⛔ stop further UI updates
                }

                console.log("datta in activirty card search", data);

                // 👇 normal suggestion dropdown
                setStudentSuggestions(data);
                setShowStudentSuggestions(true);

            } catch (err) {
                setStudentSuggestions([]);
                setShowStudentSuggestions(false);
            } finally {
                setSuggestionLoading(false);
            }
        }, 400);

        return () => clearTimeout(timer);
    }, [searchValue]);




    const searchWrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                searchWrapperRef.current &&
                !searchWrapperRef.current.contains(event.target)
            ) {
                setShowStudentSuggestions(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [activeIndex, setActiveIndex] = useState(-1);
    useEffect(() => {
        setActiveIndex(-1);
    }, [studentSuggestions]);

    const searchInputRef = useRef(null);

    useEffect(() => {
        if (searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, []);


    return (
        <>
            {isLoading ? (
                viewType === "list" ? (
                    <TableSkeleton rows={10} columns={6} showHeader={true} />
                ) : (
                    <div className="card-view-container mt-4">
                        {[...Array(20)].map((_, i) => (
                            <CardSkeleton key={i} />
                        ))}
                    </div>
                )
            ) :
                (<div className="dashboard" style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
                    {/* Content for the Dashboard */}
                    <div style={{ display: "flex", justifyContent: 'space-between', flexShrink: 0 }}>
                        <div >
                            <h2 className='main-heading'>Manage Activities</h2>
                        </div>
                        <div style={{ display: "flex", justifyContent: 'end', gap: "12px" }}>
                            {hasPermission('can-create-activity') && (<button className='add-btn'
                                onClick={() => navigate("/define-activity")}
                                style={{ padding: '10px 25px' }}>
                                <span className="me-2">
                                    <svg
                                        fill="#fff"
                                        width="27"
                                        height="27"
                                        viewBox="0 0 512 512"
                                    >
                                        <g>  <path d="M0,88v336h512V88H0z M464,376H48V136h416V376z" />
                                        </g>

                                        <g>
                                            <path d="M205.701,253.262c11.133-8.757,18.299-22.301,18.299-37.49c0-26.344-21.531-47.774-48-47.774 
                                     c-26.467,0-48,21.432-48,47.774c0,15.187,7.166,28.733,18.299,37.488C116.854,265.027,96,293.714,96,327.174h160 
                                    C256,293.714,235.146,265.027,205.701,253.262z" />
                                        </g>

                                        <g>
                                            <rect x="304" y="184" width="112" height="48" />
                                        </g>

                                        <g>
                                            <rect x="304" y="280" width="112" height="48" />
                                        </g>
                                    </svg>
                                </span>
                                Create Activity
                            </button>)}
                            {/* <button
                                className="filter-btn"
                                style={{ background: 'white', border: '2px solid #7F56DA', height: '40px' }}
                            // onClick={handleFilterClick}
                            // onClick={handleExportExcel}
                            >
                                <img src={exporticon} alt='Filter icon'></img>
                            </button> */}

                        </div>
                    </div >
                    <div className="row mt-3" style={{ flex: 1, overflow: "hidden" }}>
                        <div className={viewType === 'card' ? "col-12" : "col-md-8"} style={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
                            <div className="row align-items-end justify-content-end">
                                <div className="col-md-6 d-flex justify-content-end gap-3 align-items-center" style={{ position: "relative" }}>
                                    <div className="search-container" ref={searchWrapperRef} >
                                        {/* 🔎 Search Wrapper */}
                                        <SearchBar
                                            placeholder="Search by Registration No"
                                            ref={searchInputRef}
                                            onSearch={(value) => {
                                                setSearchValue(value);
                                                setIsSearching(!!value);
                                            }}
                                            toggleOnIcon={<GridToggleIcon isDisabled={false} />}
                                            toggleOffIcon={<GridToggleIcon isDisabled={true} />}
                                            showToggle={true}
                                            onKeyDown={(e) => {
                                                if (!showStudentSuggestions || studentSuggestions.length === 0) return;

                                                if (e.key === "ArrowDown") {
                                                    e.preventDefault();
                                                    setActiveIndex((prev) =>
                                                        prev < studentSuggestions.length - 1 ? prev + 1 : 0
                                                    );
                                                }

                                                if (e.key === "ArrowUp") {
                                                    e.preventDefault();
                                                    setActiveIndex((prev) =>
                                                        prev > 0 ? prev - 1 : studentSuggestions.length - 1
                                                    );
                                                }

                                                if (e.key === "Enter" && activeIndex >= 0) {
                                                    const act = studentSuggestions[activeIndex];
                                                    navigate(`/manage-activity/${act.id}`, {
                                                        state: { prefillSearch: searchValue }
                                                    });
                                                    setShowStudentSuggestions(false);
                                                }

                                                if (e.key === "Escape") {
                                                    setShowStudentSuggestions(false);
                                                }
                                            }}
                                        />



                                        {/* 🔽 Activity Suggestions Dropdown */}
                                        {showStudentSuggestions && (
                                            <div className="search-suggestion-box">
                                                {suggestionLoading ? (
                                                    <div className="p-2">Searching...</div>
                                                ) : studentSuggestions.length > 0 ? (
                                                    studentSuggestions.map((act, index) => (
                                                        <div
                                                            // key={act.id}
                                                            // className="suggestion-activity"
                                                            // onClick={() => {
                                                            //     navigate(`/manage-activity/${act.id}`, {
                                                            //         state: {
                                                            //             prefillSearch: searchValue
                                                            //         }
                                                            //     });
                                                            //     setShowStudentSuggestions(false);
                                                            // }}

                                                            key={act.id}
                                                            className={`suggestion-activity ${index === activeIndex ? "active" : ""
                                                                }`}
                                                            onMouseEnter={() => setActiveIndex(index)}
                                                            onClick={() => {
                                                                navigate(`/manage-activity/${act.id}`, {
                                                                    state: {
                                                                        prefillSearch: searchValue
                                                                    }
                                                                });
                                                                setShowStudentSuggestions(false);
                                                            }}
                                                        >
                                                            <div className="d-flex gap-2 align-items-start">
                                                                {/* 🔍 Icon */}
                                                                <svg
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    height="20"
                                                                    width="20"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        clipRule="evenodd"
                                                                        d="M15 10.5C15 12.9853 12.9853 15 10.5 15C8.01472 15 6 12.9853 6 10.5C6 8.01472 8.01472 6 10.5 6C12.9853 6 15 8.01472 15 10.5ZM14.1793 15.2399C13.1632 16.0297 11.8865 16.5 10.5 16.5C7.18629 16.5 4.5 13.8137 4.5 10.5C4.5 7.18629 7.18629 4.5 10.5 4.5C13.8137 4.5 16.5 7.18629 16.5 10.5C16.5 11.8865 16.0297 13.1632 15.2399 14.1792L20.0304 18.9697L18.9697 20.0303L14.1793 15.2399Z"
                                                                        fill="#080341"
                                                                    />
                                                                </svg>

                                                                <div className="activity-info">
                                                                    <div className="activity-title" style={{ display: 'flex', gap: '22px' }}>
                                                                        <div>
                                                                            {act.activity_name}
                                                                        </div>
                                                                        {act.practical_subject && (
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" }}>
                                                                                <span style={{
                                                                                    fontSize: "10px",
                                                                                    padding: "1px 6px",
                                                                                    borderRadius: "999px",
                                                                                    background: "#ede9fe",
                                                                                    color: "#7F56DA",
                                                                                    fontWeight: "600",
                                                                                }}>
                                                                                    Practical
                                                                                </span>
                                                                                <span style={{ fontSize: "11px", color: "#555" }}>
                                                                                    {act.practical_subject}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {/* ✅ Show Practical Subject if exists */}

                                                                    <div className="activity-dates">
                                                                        <span className="exam-date">
                                                                            Exam: {formatDateDDMMYYYY(act.exam_start_date)}
                                                                        </span>
                                                                        <span className="window-date">
                                                                            {formatDateDDMMYYYY(act.start_date)} → {formatDateDDMMYYYY(act.end_date)}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="p-2 text-muted">No activity found</div>
                                                )}
                                            </div>
                                        )}



                                    </div>


                                </div>
                                <div className="col-md-2">
                                    {/* <label className="form-labell">
                                        Activity Type <span className="astrisk">*</span>
                                    </label> */}

                                    <Select
                                        value={selectedActivityType}
                                        onChange={setSelectedActivityType}
                                        options={activityTypeOptions}
                                        styles={reactSelectStyles}
                                        placeholder="Select Activity Type"
                                        isClearable
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                    />

                                </div>
                            </div>
                            <div style={{ flex: 1, overflowY: "auto", marginTop: "12px", padding: '25px' }} className='activtyContainers'>
                                {filterLoading ? (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '100vh',
                                            // paddingLeft: '28%',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <SpinnerLoader />
                                    </div>
                                ) : formattedData && formattedData.length > 0 ? (
                                    viewType === 'list' ? (
                                        <AdvanceTable
                                            columns={columns}
                                            pageCounts={pageCounts}
                                            handlePageChange={handlePageChange}
                                            selectedData={selectedInstitutionsBank}
                                            data={formattedData}
                                            handleRowClick={handleRowClick}
                                            currentPage={currentPage}
                                            checkbox={false}
                                        />
                                    ) : (
                                        <div className="card-view-container item-name-clickable mt-4">
                                            {formattedData.map(activity => (
                                                <ActivityCard
                                                    key={activity.id}
                                                    activity={activity}
                                                    onClick={handleRowClick}
                                                />
                                            ))}
                                        </div>
                                    )
                                ) : (!isLoading && !isSearchLoading && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '60vh',
                                            color: '#888',
                                            borderRadius: '8px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        No  Data available.
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* Only show EventShortDetails in table view */}
                        {viewType === 'list' && (
                            <div className="col-md-4">
                                {/* <ActivitiesShortDetails selectedDetails={selectedInstitutionsBank} /> */}
                            </div>
                        )}
                    </div>
                </div>)}


        </>
    );
};


export default ActivitiesDashboard